import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { caseInsensitiveSelectFilterOption } from '../../../helpers/caseInsensitiveSelectFilterOption';
import { Option, Select } from '../../../system/components/Select';

interface Props {
  form: WrappedFormUtils;
  required?: boolean;
}

const states = [
  { abbreviation: 'AK', name: 'Alaska' },
  { abbreviation: 'AL', name: 'Alabama' },
  { abbreviation: 'AR', name: 'Arkansas' },
  { abbreviation: 'AZ', name: 'Arizona' },
  { abbreviation: 'CA', name: 'California' },
  { abbreviation: 'CO', name: 'Colorado' },
  { abbreviation: 'CT', name: 'Connecticut' },
  { abbreviation: 'DC', name: 'District of Columbia' },
  { abbreviation: 'DE', name: 'Delaware' },
  { abbreviation: 'FL', name: 'Florida' },
  { abbreviation: 'GA', name: 'Georgia' },
  { abbreviation: 'HI', name: 'Hawaii' },
  { abbreviation: 'IA', name: 'Iowa' },
  { abbreviation: 'ID', name: 'Idaho' },
  { abbreviation: 'IL', name: 'Illinois' },
  { abbreviation: 'IN', name: 'Indiana' },
  { abbreviation: 'KS', name: 'Kansas' },
  { abbreviation: 'KY', name: 'Kentucky' },
  { abbreviation: 'LA', name: 'Louisiana' },
  { abbreviation: 'MA', name: 'Massachusetts' },
  { abbreviation: 'MD', name: 'Maryland' },
  { abbreviation: 'ME', name: 'Maine' },
  { abbreviation: 'MI', name: 'Michigan' },
  { abbreviation: 'MN', name: 'Minnesota' },
  { abbreviation: 'MO', name: 'Missouri' },
  { abbreviation: 'MS', name: 'Mississippi' },
  { abbreviation: 'MT', name: 'Montana' },
  { abbreviation: 'NC', name: 'North Carolina' },
  { abbreviation: 'ND', name: 'North Dakota' },
  { abbreviation: 'NE', name: 'Nebraska' },
  { abbreviation: 'NH', name: 'New Hampshire' },
  { abbreviation: 'NJ', name: 'New Jersey' },
  { abbreviation: 'NM', name: 'New Mexico' },
  { abbreviation: 'NV', name: 'Nevada' },
  { abbreviation: 'NY', name: 'New York' },
  { abbreviation: 'OH', name: 'Ohio' },
  { abbreviation: 'OK', name: 'Oklahoma' },
  { abbreviation: 'OR', name: 'Oregon' },
  { abbreviation: 'PA', name: 'Pennsylvania' },
  { abbreviation: 'RI', name: 'Rhode Island' },
  { abbreviation: 'SC', name: 'South Carolina' },
  { abbreviation: 'SD', name: 'South Dakota' },
  { abbreviation: 'TN', name: 'Tennessee' },
  { abbreviation: 'TX', name: 'Texas' },
  { abbreviation: 'UT', name: 'Utah' },
  { abbreviation: 'VA', name: 'Virginia' },
  { abbreviation: 'VT', name: 'Vermont' },
  { abbreviation: 'WA', name: 'Washington' },
  { abbreviation: 'WI', name: 'Wisconsin' },
  { abbreviation: 'WV', name: 'West Virginia' },
  { abbreviation: 'WY', name: 'Wyoming' },
];

export const SelectPatientState: FC<Props> = ({ form, required = false }): JSX.Element => (
  <Form.Item label="State">
    {form.getFieldDecorator('state', { rules: [{ required: required, message: "Please enter patient's state." }] })(
      <Select filterOption={caseInsensitiveSelectFilterOption} placeholder="State" showSearch>
        {states.map(state => (
          <Option value={state.abbreviation} key={`state-${state.abbreviation}`}>
            {state.abbreviation}
          </Option>
        ))}
      </Select>
    )}
  </Form.Item>
);
